export default {
  title: 'Modelos Ad-Hoc',
  createButton: 'Crear Modelo Ad-Hoc',
  searchLabel: 'Buscar',
  ok: 'Ok',
  headers: {
    modelName: 'Nombre del Modelo',
    codename: 'Nombre Código',
    pkl: 'PKL',
    pklSize: 'Tamaño PKL',
    modified: 'Modificado',
    status: 'Estado',
    actions: 'Acciones'
  },
  tooltips: {
    recalculateModelReport: 'Recalcular Reporte del Modelo',
    editAdHocModel: 'Editar Modelo Ad-Hoc',
    deploy: 'Desplegar',
    deleteAdHocModel: 'Eliminar Modelo Ad-Hoc',
    version: 'Versión'
  },
  deployDialog: {
    title: 'Desplegar Modelo',
    sourceModelName: 'Nombre del modelo origen',
    targetModelName: 'Nombre del modelo destino',
    targetEnvironment: 'Entorno destino:',
    confirmLabel: "Escribe 'deploy' para confirmar el despliegue en el entorno seleccionado",
    cancel: 'Cancelar',
    deploy: 'Desplegar',
    deploying: 'Desplegando modelo... Por favor espera unos segundos',
    modelSuccessfullyDeployed: 'Modelo desplegado exitosamente',
    errorModelNameExists: 'El nombre del modelo ya existe en el entorno destino',
    internalError: 'Error interno'
  },
  deleteDialog: {
    title: 'Advertencia',
    deletingAdHocModel: 'Eliminando Modelo Ad-Hoc:',
    confirmMessage: 'Podrás recuperarlo durante 7 días solicitándolo a un administrador. ¿Estás seguro?',
    cancel: 'Cancelar',
    delete: 'Eliminar'
  },
  current: 'actual',
  versionDeployed: 'Desplegada el {date}',
  versionTooltip: 'Versión de {name}',
  versionDialog: {
    title: 'Versión del modelo',
    cancel: 'Cancelar',
    save: 'Guardar',
    linked: '{name} ahora es la v{version}. Se copió el acceso a {grants} usuarios y {groups} grupos.'
  },
  versionErrors: {
    notLatestVersion: 'Solo se puede desenlazar la última versión de una familia',
    alreadyInFamily: 'Este modelo ya es versión de otro modelo. Desenlázalo primero',
    isFamilyRoot: 'Este modelo es la primera versión de su propia familia, así que no puede ser versión de otro modelo',
    familyNotFound: 'El modelo seleccionado ya no existe',
    modelNotFound: 'Este modelo ya no existe',
    notAdHoc: 'Solo los modelos Ad-Hoc pueden tener versiones',
    internal: 'No se pudo guardar la versión',
    linkOnCreate: 'Se creó {name}, pero no se pudo enlazar como nueva versión: {reason}'
  },
  snackbar: {
    recalculating: 'Recalculando reporte del modelo para {name}...',
    recalculationStarted: 'Se inició el recálculo del reporte del modelo para {name}. Se te notificará cuando esté listo.',
    recalculationError: 'Error al recalcular el reporte del modelo para {name}',
    deleteError: 'Error al eliminar {name}'
  }
}
